<template>
  <a-drawer width="50%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="门店名称" prop="shopId">
        <!--        <a-input v-model="form.shopId" placeholder="请输入门店ID，外键{shop.id}" />-->
        <a-select
          placeholder="全部"
          show-search
          v-model:value="form.shopId"
          option-filter-prop="children"
          :filterOption="filterOption"
        >
          <a-select-option v-model:value="item.id" v-for="(item, index) in courseList" :key="index">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="教练名称" prop="nickname">
        <a-input v-model="form.nickname" placeholder="请输入教练名称" />
      </a-form-model-item>

      <a-form-model-item label="擅长" prop="superiority">
        <a-select
          mode="multiple"
          placeholder="全部"
          :value="banse_courseLabel"
          style="width: 100%"
          @change="setCourseList"
        >
          <a-select-option :value="item.name" v-for="(item, index) in courseLabelList" :key="item.id" >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>


      <a-form-model-item label="教练头像" prop="avatar">
        <file-upload type="image" :defaultList="form.imgArr" :count="1" :imgSize="'188*253'" @input="getImg($event, 'avatar')"></file-upload>
      </a-form-model-item>
<!-- 5-30 要求隐藏-->
<!--      <a-form-model-item label="教练标题" prop="title">-->
<!--        <a-input v-model="form.title" placeholder="请输入教练标题" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="教练姓名" prop="name">-->
<!--        <a-input v-model="form.name" placeholder="请输入教练姓名" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="个人简介" prop="content">
        <a-textarea v-model="form.content" placeholder="请输入个人简介" :auto-size="{ minRows: 8, maxRows: 10 }" />
      </a-form-model-item>
      <a-form-model-item label="教练视频" prop="video">
        <file-upload
          type="file"
          :defaultList="form.videoArr"
          :count="form.videoCount"
          @input="getImg($event, 'video')"
        ></file-upload>

        <video
          v-if="form.video"
          style="width: 180px; height: 120px"
          class="avatar video-avatar"
          controls="controls"
          :src="form.videoArr[0].url"
        />
      </a-form-model-item>

      <a-form-model-item label="相关图片" prop="picture">
        <file-upload
          type="image"
          :defaultList="form.imgArr1"
          :count="3"
          @input="getImg($event, 'picture')"
        ></file-upload>
      </a-form-model-item>

      <a-form-model-item label="相关证书" prop="certificate">
        <!-- <PlusSquareTwoTone  twoToneColor="#eb2f96"/> -->
        <!-- <file-upload type="image" :defaultList="form.imgArr2" :count="3"
        @input="getImg($event, 'certificate')"></file-upload> -->
        <a-button type="info" @click="addList" >+证书信息</a-button>
        <div style="height:300px;overflow: auto">
          <a-table :data-source="tabulationData" :columns="tabulationColumn" rowKey="id"  :pagination="false" bordered>
            <div slot="tabulationName" slot-scope="text, record">
              <a-input v-model="record.tabulationName" :placeholder="$t('请输入') + $t('证书名称')"/>
            </div>
            <div slot="tabulationTime" slot-scope="text, record">
              <a-date-picker  style="width: 100%" v-model="record.tabulationTime"  format="YYYY-MM-DD" valueFormat="YYYY-MM-DD" allow-clear/>

            </div>
            <div slot="tabulationPicture" slot-scope="text, record" v-viewer>
              <img :src="record.tabulationPicture" style="width:100%" v-if='!record.id' >
              <file-upload
                type="image"
                :defaultList="record.tabulationPicture"
                :count="1"
                @input="getImgs($event, 'picture', record)"
              ></file-upload>

            </div>
            <!-- <div slot="valuePicture" slot-scope="text, record"></div> -->
                        <div slot="action" slot-scope="text, record,index" >
                          <a-popconfirm
                            title="确定要删除此条证书信息吗？"
                            ok-text="确定"
                            cancel-text="取消"
                            @confirm="delTabulation(record,index)"
                          >
                            <a href="javascript:void(0)" style="color: red">删除</a>
                          </a-popconfirm>
                        </div>
          </a-table>
        </div>
      </a-form-model-item>

      <a-form-model-item label="教练手机号" prop="phone">
        <a-input v-model="form.phone" placeholder="请输入教练手机号" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getShopShop, addShopShop, updateShopShop } from '@/api/coach/shopShop'
import Editor from '@/components/Editor'
import { shopName } from '@/api/student/student'
import { guid } from '@/utils/ruoyi'
import {labelCourse, versionCourse} from "@/api/course/course";

export default {
  name: 'CreateForm',
  props: {},
  components: {
    Editor,
  },
  data() {
    return {
      videoArr: [],
      banse_courseLabel:[],
      base_courseLabelList:[],
      submitLoading: false,
      formTitle: '',
      courseList: [],
      // 表单参数
      form: {
        id: null,
        imgArr: [],
        shopId: null,

        nickname: null,
        superiority: null,

        avatar: null,

        title: null,

        name: null,

        content: null,

        picture: null,
        video: null,

        certificate: null,

        phone: null,

        createTime: null,

        remark: null,
      },
      tabulationData: [],
      tabulationNum: 0,
      tabulationColumn: [
        {
          title: this.$t('证书名称'),
          key: 'tabulationName',
          scopedSlots: { customRender: 'tabulationName' },

        },

        {
          title: this.$t('时间'),
          dataIndex: 'tabulationTime',
          key: 'tabulationTime',
          scopedSlots: { customRender: 'tabulationTime' },
          width:200,
        },
        {
          title: '图片',
          dataIndex: 'tabulationPicture',
          key: 'tabulationPicture',
          width:160,
          scopedSlots: { customRender: 'tabulationPicture' },
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          key: 'action',
          width:100,
          // slots: { title: 'addbtn', customRender: 'name' },
          scopedSlots: { customRender: 'action' },
        },
      ],
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        shopId: [{ required: true, message: '门店名称不能为空', trigger: 'blur' }],
        nickname: [{ required: true, min: 0, max: 50, message: '教练名称不能为空并不能超过50字符', trigger: 'blur' }],
        avatar: [{ required: true, message: '教练头像不能为空', trigger: 'blur' }],
        // title: [{ required: true, min: 0, max: 200, message: '教练标题不能为空并不能超过200字符', trigger: 'blur' }],
        // name: [{ required: true, min: 0, max: 20, message: '教练姓名不能为空并不能超过20字符', trigger: 'blur' }],
        video: [{ required: true, message: '教练视频不能为空', trigger: 'blur' }],
        certificate: [{ required: true, message: '相关证书不能为空', trigger: 'blur' }],
        content: [{ required: true, message: '个人简介不能为空', trigger: 'blur' }],
        picture: [{ required: true, message: '相关图片不能为空', trigger: 'blur' }],
        phone: [{ required: true, min: 11, max: 11, message: '教练手机号不能为空并必须是11位', trigger: 'blur' }],
      },
    }
  },
  filters: {},
  created() {},
  computed: {
    courseLabelList() {
      return this.base_courseLabelList.filter(o => !this.banse_courseLabel.includes(o.name));
    },
    courseLabel() {
      return this.base_courseLabelList.filter(o => this.banse_courseLabel.includes(o.name)).map(item=>item.id)
    },

  },
  watch: {},
  mounted() {},
  methods: {
    addList() {
      this.tabulationNum + 1
      this.tabulationData.push({
        id:this.tabulationNum + 1,
        tabulationName: '',
        tabulationTime: '',
        pictureArr: [],
        picture: '',
      })
    },
    filterOption(input, option) {
      // 重点在这
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },

    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      videoArr: [], (this.formType = 1)
      this.banse_courseLabel = [],
      this.form = {
        id: null,
        imgArr: [],
        shopId: null,
        nickname: null,
        superiority: null,
        avatar: null,
        title: null,
        name: null,
        content: null,
        picture: null,
        video: null,
        certificate: null,
        phone: null,
        createTime: null,
        remark: null,
      }
      this.tabulationData = []
      this.tabulationNum = 0
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    delTabulation(row,index){
      this.tabulationData.splice(index, 1)
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
      this.getCourseList()
      this.getLabelList()
    },

    //设置多选值
    setCourseList(selectedItems) {
      // console.log(selectedItems)
      this.banse_courseLabel = selectedItems;
      //这是最终要提交的地址
      console.log(this.courseLabel)
    },
    /** 查询标签名称 */
    getLabelList() {
      labelCourse({type:5}).then(Response => {
          console.log(Response)
          this.base_courseLabelList = Response.data;
        }
      )
    },


    /** 查询门店名称 */
    getCourseList() {
      shopName().then((Response) => {
        console.log(Response)
        this.courseList = Response.data
      })
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.getCourseList()
      this.getLabelList()
      this.formType = 2
      const id = row ? row.id : ids
      getShopShop({ id: id }).then((response) => {
        console.log(JSON.parse(response.data.certificate),"返回",response.data.certificate)
        this.tabulationData = JSON.parse(response.data.certificate)
        console.log(JSON.parse(response.data.certificate),"返回",response.data.certificate)
        this.tabulationData = JSON.parse(response.data.certificate)
        this.form = response.data
        this.form.picture = response.data.picture
        // this.form.certificate = response.data.certificate
        // this.form.certificate = response.data.certificate
        let that = this
        this.form.imgArr = []
        this.form.imgArr.push({
          uid: guid(8, 10),
          name: that.form.avatar,
          status: 'done',
          halfUrl: that.form.avatar,
          url: that.form.avatar,
          path: that.form.avatar,
        })

        this.form.imgArr1 = []
        if (this.form.picture) {
          this.form.picture.split(',').forEach((item) => {
            that.form.imgArr1.push({
              uid: guid(8, 10),
              name: item,
              status: 'done',
              halfUrl: item,
              url: item,
              path: item,
            })
          })
        }

        this.form.imgArr2 = []
        if (this.form.certificate) {
          this.form.certificate.split(',').forEach((item) => {
            that.form.imgArr2.push({
              uid: guid(8, 10),
              name: item,
              status: 'done',
              halfUrl: item,
              url: item,
              path: item,
            })
          })
        }

        this.form.videoArr = []
        this.form.videoArr.push({
          uid: guid(8, 10),
          name: that.form.video,
          status: 'done',
          halfUrl: that.form.video,
          url: that.form.video,
          path: that.form.video,
        })

        this.open = true
        this.formTitle = '修改'

         //  修改回显:
      let tem_arr = this.form.superiority.split(",");
      this.banse_courseLabel = this.base_courseLabelList.filter(o => tem_arr.includes(o.id)).map(item=>item.name)

      })

    },
    /**上传图片成功回调 */
    getImgs(info, fieldName, record) {
      console.log('info', info)
      if (info.length === 0) {
        record[fieldName] = ''
        record[`${fieldName}Arr`] = []
      } else {
        if (record[`${fieldName}Count`] === 1) {
          record[fieldName] = info[0].url
          record[`${fieldName}Arr`] = info
        } else {
          record[fieldName] = info
            .map((ele) => {
              return ele.url
            })
            .join(',')
          record[`${fieldName}Arr`] = info
        }
      }
    },
    /** 提交按钮 */
    submitForm: function () {
      this.form.superiority = this.courseLabel.join(",")
      var nums = 0
      // var certLin = this.tabulationData.filter((item,j)=>{
      //   return  item.id
      // })
      var certificate = this.tabulationData.map((item,i)=>{
      // var certLin = this.tabulationData.filter((item,j)=>{
      //   return  item.id
      // })
      var certificate = this.tabulationData.map((item,i)=>{
        if(item.tabulationName==""||item.tabulationTime==""){
          nums = 1
        }
          return  {
            tabulationName:item.tabulationName,
            tabulationTime:item.tabulationTime,
            tabulationPicture:item.hasOwnProperty('tabulationPicture')?item.tabulationPicture:item.picture
          }


      })
      console.log(certificate,"certificate")
      this.form.certificate = (JSON.stringify(certificate))
      if(certificate.length==0||nums==1){
        this.$message.error("相关证书名字/日期/文件不能为空 ")
      }else{
        this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateShopShop(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          } else {
            addShopShop(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          }
        } else {
          return false
        }
      })
    }
  })
    },

    /******************** 上传图片数据处理 start ********************/
    /**前端 需要将图片格式处理成数组，方便数据回显 */
    setImgData(field, img) {
      let fieldImgArr = []
      if (img.indexOf(',') === -1) {
        // 单图
        if (this.form[`${field}Count`] === 1) {
          if (img) {
            fieldImgArr.push({
              uid: guid(8, 10),
              name: img,
              status: 'done',
              halfUrl: img,
              url: img,
              path: img,
            })
          }
        }
      } else {
        // 多图
        if (this.form[`${field}Count`] > 1) {
          let imgArr = img.split(',')
          if (imgArr.length) {
            imgArr.map((item) => {
              fieldImgArr.push({
                uid: guid(8, 10),
                name: img,
                status: 'done',
                halfUrl: img,
                url: item,
                path: item,
              })
            })
          }
        }
      }
      return fieldImgArr
    },
    /**上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info', info)
      if (info.length === 0) {
        this.form[fieldName] = ''
        this.form[`${fieldName}Arr`] = []
      } else {
        if (this.form[`${fieldName}Count`] === 1) {
          this.form[fieldName] = info[0].url
          this.form[`${fieldName}Arr`] = info
        } else {
          this.form[fieldName] = info
            .map((ele) => {
              return ele.url
            })
            .join(',')
          this.form[`${fieldName}Arr`] = info
        }
      }
    },
    /** 点击视频 弹窗打窗口播放视频*/
    async handlePreview(file) {
      this.previewImage = this.form.video || file.video
      this.previewVisible = true
      this.$nextTick(() => {
        this.$refs.myVideo.play()
      })
    },
    handleCancel() {
      this.previewVisible = false
    }

  }
}
</script>
